// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-status-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  margin-top: 80px;
  padding: 20px;
  background-color: #303030;
}

.payment-status-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 30px;
  width: 100%;
  max-width: 550px;
  text-align: center;
}

.status-verifying,
.status-success,
.status-failed {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.success-icon,
.failed-icon {
  font-size: 60px;
  margin-bottom: 20px;
}

.confirmation-message {
  color: #666;
  margin-bottom: 25px;
}

.order-details {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
  width: 100%;
  text-align: left;
}

.order-details h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #333;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.detail-row:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.detail-label {
  font-weight: 600;
  color: #555;
}

.detail-value {
  color: #333;
}

.failure-reasons {
  text-align: left;
  color: #666;
  margin: 15px 0;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin: 25px 0;
}

.btn-primary,
.btn-secondary {
  padding: 12px 20px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  font-size: 16px;
}

.btn-primary {
  background-color: #4CAF50;
  color: white;
}

.btn-primary:hover {
  background-color: #45a049;
}

.btn-secondary {
  background-color: #f1f1f1;
  color: #333;
}

.btn-secondary:hover {
  background-color: #e2e2e2;
}

.support-text {
  color: #666;
  font-size: 14px;
  margin-top: 20px;
}

@media (max-width: 768px) {
    .payment-status-container {
        padding: 20px 10px;
    }
}


@media (max-width: 600px) {
  .payment-status-card {
    padding: 20px;
  }
  
  .action-buttons {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PaymentStatus.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;;AAGA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".payment-status-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 80vh;\n  margin-top: 80px;\n  padding: 20px;\n  background-color: #303030;\n}\n\n.payment-status-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  padding: 30px;\n  width: 100%;\n  max-width: 550px;\n  text-align: center;\n}\n\n.status-verifying,\n.status-success,\n.status-failed {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.loading-spinner {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #3498db;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.success-icon,\n.failed-icon {\n  font-size: 60px;\n  margin-bottom: 20px;\n}\n\n.confirmation-message {\n  color: #666;\n  margin-bottom: 25px;\n}\n\n.order-details {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 20px;\n  margin: 20px 0;\n  width: 100%;\n  text-align: left;\n}\n\n.order-details h3 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  color: #333;\n}\n\n.detail-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eee;\n}\n\n.detail-row:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.detail-label {\n  font-weight: 600;\n  color: #555;\n}\n\n.detail-value {\n  color: #333;\n}\n\n.failure-reasons {\n  text-align: left;\n  color: #666;\n  margin: 15px 0;\n}\n\n.action-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  margin: 25px 0;\n}\n\n.btn-primary,\n.btn-secondary {\n  padding: 12px 20px;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  font-size: 16px;\n}\n\n.btn-primary {\n  background-color: #4CAF50;\n  color: white;\n}\n\n.btn-primary:hover {\n  background-color: #45a049;\n}\n\n.btn-secondary {\n  background-color: #f1f1f1;\n  color: #333;\n}\n\n.btn-secondary:hover {\n  background-color: #e2e2e2;\n}\n\n.support-text {\n  color: #666;\n  font-size: 14px;\n  margin-top: 20px;\n}\n\n@media (max-width: 768px) {\n    .payment-status-container {\n        padding: 20px 10px;\n    }\n}\n\n\n@media (max-width: 600px) {\n  .payment-status-card {\n    padding: 20px;\n  }\n  \n  .action-buttons {\n    flex-direction: column;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
